import { ReactNode } from 'react';
import { Navigate, To } from 'react-router-dom';
import { useHasAllowedRole } from '~/hooks/useUserRole';
import { RouteConfig } from '~/routes/routeConfig';
import { UserRole } from '~/types/company';

interface UserRolesGuardProps {
  allowedRoles: UserRole[];
  children: ReactNode;
  redirectTo?: To;
}

/**
 * Guard that restricts access based on the active company user role.
 *
 * @param allowedRoles - User roles allowed to access the route.
 * @param children - The content to render if access is granted.
 * @param redirectTo - Optional redirect path if role validation fails.
 * @constructor
 */
const UserRolesGuard: React.FC<UserRolesGuardProps> = ({ allowedRoles, children, redirectTo }) => {
  const hasAllowedRole = useHasAllowedRole(allowedRoles);

  if (!hasAllowedRole) return <Navigate replace to={redirectTo ?? RouteConfig.AppRoot.buildLink()} />;

  return <>{children}</>;
};

export default UserRolesGuard;
